import React from 'react';

import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';

import { Button, Col, Grid, ListGroup, Row } from '@shared/components/bootstrap';

type IAccordionProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const Toggle: React.FC<{
  collapsed: boolean;
  onToggle(isCollapsed: boolean): void;
}> = ({ collapsed, onToggle, children }) => (
  <ListGroup.Item>
    <Row>
      <Col md={11}>{children}</Col>
      <Col md={1} className="text-right">
        <Button onClick={() => onToggle(!collapsed)}>
          <FontAwesomeIcon icon={collapsed ? faPlus : faMinus} />
        </Button>
      </Col>
    </Row>
  </ListGroup.Item>
);

const Collapse: React.FC<{ collapsed: boolean }> = ({ collapsed, children }) => {
  if (collapsed) {
    return null;
  }
  return <ListGroup.Item>{children}</ListGroup.Item>;
};

const Accordion: React.FC<IAccordionProps> = ({ children }) => (
  <Grid fluid className="accordion">
    <ListGroup>{children}</ListGroup>
  </Grid>
);

const Combined = Object.assign(Accordion, {
  Toggle,
  Collapse,
});

export { Combined as Accordion };
